import React from "react";
import PostTags from "./PostTags";
import BackgroundImage from "gatsby-background-image";
import { Link } from "gatsby";
import Pluralize from "../../../node_modules/pluralize";
import _ from "lodash";

class Card extends React.Component {
  render() {
    console.log(this.props.callToAction);
    return (
      <>
        <BackgroundImage
          className="insight-graphic"
          fluid={this.props.thumb}
          style={{
            backgroundSize: `cover`
          }}
        >
          {this.props.youtubeId ? <i class="far fa-play-circle" /> : ``}
        </BackgroundImage>
        <div className="insight-excerpt">
          {this.props.preface ? (
            <>
              <span
                className={
                  `preface ` + (this.props.featured ? `hot-pink-text` : ``)
                }
              >
                {this.props.preface}
              </span>
            </>
          ) : (
            ``
          )}
          <h3 className="h6">{this.props.title}</h3>
          {this.props.featured && this.props.externalUrl ? (
            <a
              href={this.props.externalUrl}
              className="button hot-pink small narrow"
              target="_blank"
            >
              {this.props.callToAction}
            </a>
          ) : (
            ``
          )}
          <small>
            <div className="post-tag-container">
              <span>
                <Link
                  key={this.props.title}
                  to={`/categories/${Pluralize(
                    _.kebabCase(this.props.category)
                  )}/`}
                  activeClassName="active"
                >
                  <i className={this.props.iconClass} /> {this.props.category}
                </Link>
              </span>
              <span>
                <i className="fas fa-tags" /> &nbsp;
                <PostTags tags={this.props.tags} />
              </span>
            </div>
          </small>
        </div>
      </>
    );
  }
}

export default Card;
